import type { LocationType } from '@shared/core/appointment-types'
import { Ban, House, MapPin, Pencil, Phone, Video, type LucideIcon } from 'lucide-react'

export const LOCATION_ICONS: Record<LocationType, LucideIcon> = {
  none: Ban,
  google_meet: Video,
  in_person: MapPin,
  phone: Phone,
  customer_address: House,
  custom: Pencil,
}
